import { useContext } from "react";
import { BoitelSaleScenarioNewContext } from "../../contexts/boitelSaleScenarioNewContext";

export default function useBoitelSaleScnearioNewContext() {
  const value = useContext(BoitelSaleScenarioNewContext);
  return value;
}
